import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from '../../../../../global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingScreenService } from '../../../../../services/loading-screen/loading-screen.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Service } from 'src/app/services';
@Component({
  selector: 'app-create-account-iptv',
  templateUrl: './create-account-iptv.component.html',
  styleUrls: ['./create-account-iptv.component.sass']
})
export class CreateAccountIptvComponent implements OnInit {
  @Input() indexTab:number;
  @Input() selectsToDisplay:any = [];
  @Output() nextTabOut = new EventEmitter<any>();
  @Output() selectsToDisplayOut = new EventEmitter<any>();
  public screen: number = Number(sessionStorage.getItem("PlanSelectionScreen"));
  public session: number = 0;
  public content: object | undefined;
  public createIptv: boolean = true;
  signupForm: FormGroup
  constructor(public dialog: MatDialog, private active: ActivatedRoute, public global: GlobalService, private router: Router, private loadingScreenService: LoadingScreenService, private builder: FormBuilder, private services: Service) {
    this.signupForm = this.builder.group({
      email: ['', Validators.compose([Validators.email, Validators.required])]
    });
  }
  ngOnInit() {
    if (this.screen == 0) {
      this.screen = 1;
    }
    this.global.tokenShop=sessionStorage.getItem("tokenShop");
  }
  changeTab(idSession: number) {
    this.session = idSession;
  }
  continue() {
    sessionStorage.setItem("email", this.signupForm.get('email')?.value);
    this.selectsToDisplay[this.indexTab]=' : '+this.signupForm.get('email')?.value;
    this.selectsToDisplayOut.emit(this.selectsToDisplay);
    this.nextTabOut.emit()
  }
  validador() {
    if (this.signupForm.get('email')?.status == "INVALID" || this.signupForm.get('email')?.hasError('required') || this.signupForm.get('email')?.value == "") {
      this.global.notif(" Por favor, ingresa un correo electrónico valido.");
    }
    else {
      this.loadingScreenService.startLoading();
      this.services.validateIptv2Account(this.signupForm.get('email')?.value,this.global.tokenShop).subscribe((data: any) => {
        this.loadingScreenService.stopLoading();
        if (data.hasError == false) {
          this.createIptv = false;

        }
        else {
          this.global.notif(data.errorDesc)
        }
      });

    }
  }
}
